import { createStyles, makeStyles } from '@mui/styles'

const useStyles = makeStyles(() =>
  createStyles({
    box: {
      height: '100%',
    },
    body: {
      display: 'flex',
      flexDirection: 'column',
      gap: 30,
    },
    footer: {
      display: 'flex',
      flexDirection: 'column',
      gap: 15,
    },
    footer__controls: {
      display: 'flex',
      justifyContent: 'flex-end',
      alignItems: 'center',
    },
    table: {
      width: '100%',
    },
    table__header: {
      paddingBottom: 10,
      '& > div': {
        border: 0,
      },
    },
    table__body: {
      minHeight: 160,
    },
    table__row: {
      display: 'flex',
      justifyContent: 'flex-start',
      alignItems: 'center',
      borderTop: '1px solid #C4C4C4',
      gap: 95,
      '& > div': {
        width: 100,
      },
    },
    th: {
      fontWeight: 800,
      fontSize: 14,
    },
    td: {
      padding: '12px 0',
      '& div:nth-of-type(2)': {
        paddingLeft: 8,
      },
    },
    error_message: {
      padding: '12px 0',
      color: 'orange',
      fontWeight: 700,
    },
  })
)
export default useStyles
